import styled from "@emotion/styled";

export const MainViewContainer = styled.div`
  width: ${(p) => (p.isFullPageLayout ? "100%" : "100%")};
  height: 100vh;
  overflow-y: auto;
`;
